import { showSpinner, hideSpinner } from "store/slices/spinner";
import {
  getCategoriesService,
  getProgProductsService,
  getProgLaborCodesService,
  createProgramService,
  programSearchService,
  addCategoriesService,
  addLineItemsService,
  getCategoriesListService,
  getLineItemsService,
  getProgramDetailsService,
  getLineItemPricesService,
  addLineItemPricesService,
  updateLineItemPricesService,
  editProgramDetailService,
  updateLineItemDataService,
  deleteLineItemDataService,
  deleteProductDataService,
} from "services/programBuilder.service";
import { getStoreNoList } from "services/laborTable.service";
import { getlaborCodeList } from "services/siteRepo.service";
import {
  resetState as resetStateAction,
  getCategoriesList as getCategoriesListAction,
  getProductsList as getProductsListAction,
  getLaborCodesList as getLaborCodeListAction,
  getStoresNoList as getStoresNoListAction,
  getLaborCodeOptions as getLaborCodeOptionsAction,
  clearLookupData as clearLookupDataAction,
  programSearchSubmitSuccess as programSearchSubmitSuccessAction,
  updateSearchFilterValue as updateSearchFilterValueAction,
  clearProgSearchData as clearProgSearchDataAction,
  addCategory as addCategoryAction,
  addLineItems as addLineItemsAction,
  getCategoriesData as getCategoriesDataAction,
  getLineItemsData as getLineItemsDataAction,
  getProgramDetails as getProgramDetailsAction,
  getLineItemPrices as getLineItemPricesAction,
  addLineItemPrices as addLineItemPricesAction,
  updateProgramDetails as updateProgramDetailsAction,
  updateLineItemData as updateLineItemDataAction,
  deleteLineItemData as deleteLineItemDataAction,
  deleteProductData as deleteProductDataAction,
} from "store/slices/programBuilder";

export const resetState = () => (dispatch) => {
  dispatch(resetStateAction());
};

export const getCategoriesList = (typeId) => (dispatch) => {
  dispatch(showSpinner());
  getCategoriesService(typeId).then((response) => {
    dispatch(getCategoriesListAction(response));
    dispatch(hideSpinner());
  });
};

export const getProductList = (categoryId) => (dispatch) => {
  dispatch(showSpinner());
  getProgProductsService(categoryId).then((response) => {
    dispatch(getProductsListAction(response));
    dispatch(hideSpinner());
  });
};

export const getLaborCodesList = (categoryId) => (dispatch) => {
  dispatch(showSpinner());
  getProgLaborCodesService(categoryId).then((response) => {
    dispatch(getLaborCodeListAction(response));
    dispatch(hideSpinner());
  });
};

export const getStoreNumList = () => (dispatch) => {
  getStoreNoList().then((response) => {
    dispatch(getStoresNoListAction(response));
  });
};

export const getlaborCodeOptions = () => (dispatch) => {
  getlaborCodeList().then((response) => {
    dispatch(getLaborCodeOptionsAction(response));
  });
};

export const clearLookupData = () => (dispatch) => {
  dispatch(clearLookupDataAction());
};

export const createProgram = (data) => async (dispatch) => {
  dispatch(showSpinner());
  return createProgramService(data)
    .then((res) => {
      dispatch(hideSpinner());
      return res;
    })
    .catch((err) => {
      dispatch(hideSpinner());
    });
};

export const programSearch = (data) => async (dispatch) => {
  dispatch(showSpinner());
  return programSearchService(data)
    .then((res) => {
      res
        ?.sort((a, b) => {
          const getRecentDate = (item) =>
            item.updatedDate && item.updatedDate !== null ? new Date(item?.updatedDate) : new Date(item?.createdDate);
          const aRecent = getRecentDate(a);
          const bRecent = getRecentDate(b);
          return bRecent - aRecent;
        })
        ?.map((ele) => {
          ele.updatedDate = ele.updatedDate === null ? "" : new Date(ele.updatedDate).toLocaleDateString("en-US");
          ele.createdDate = ele.createdDate === null ? "" : new Date(ele.createdDate).toLocaleDateString("en-US");
        });
      dispatch(programSearchSubmitSuccessAction(res));
      dispatch(hideSpinner());
    })
    .catch((err) => {
      dispatch(hideSpinner());
    });
};

export const updateSearchFilterValue = (payload) => (dispatch) => {
  dispatch(updateSearchFilterValueAction(payload));
};

export const clearProgramSearchData = () => (dispatch) => {
  dispatch(clearProgSearchDataAction());
};

export const addProductCategory =
  (data, isDuplicate = false) =>
  async (dispatch) => {
    dispatch(showSpinner());
    let categoriesPayload = {
      programId: data.programId,
      categoryId: data.isAlaCarte ? 11 : data.categoryId,
      categoryName: data.categoryName,
      typeId: data.isAlaCarte ? 3 : data.typeId,
      createdBy: data.createdBy,
    };

    try {
      const res = await addCategoriesService(categoriesPayload);
      if (res) {
        dispatch(addCategoryAction(res));

        let laborCodesArr = [];
        if (data.laborCodes.length) {
          data.laborCodes?.map((item) => {
            let tempObj = {
              productId: res.productId,
              name: "",
              laborCodeId: item.laborCodeId,
              laborCode: item.laborCode,
              laborCodeDesc: item.laborCodeDescription,
              createdBy: data.createdBy,
              unitOfMeasurement: item.unitOfMeasurement,
              programId: parseInt(data.programId),
            };
            laborCodesArr.push(tempObj);
          });
        }

        let productsArr = [];
        if (data.products.length) {
          data.products?.map((item) => {
            let tempObj = {
              productId: res.productId,
              name: item.name,
              unitOfMeasurement: item.unitOfMeasurement,
              laborCodeId: "",
              createdBy: data.createdBy,
              programId: parseInt(data.programId),
            };
            productsArr.push(tempObj);
          });
        }

        let lineItemsPayload = [...laborCodesArr, ...productsArr];
        const lineItemsRes = await Promise.all(
          lineItemsPayload.map((item) => {
            return addLineItemsService(item)
              .then((lineItemRes) => {
                dispatch(addLineItemsAction(lineItemRes));

                if (isDuplicate) {
                  return lineItemRes;
                }
              })
              .catch((err) => {
                console.log("err in add line items", err);
                dispatch(hideSpinner());
              });
          }),
        );

        if (!isDuplicate) dispatch(getLineItemPricesData(data.programId));

        if (isDuplicate) return lineItemsRes;
      }
    } catch (err) {
      dispatch(hideSpinner());
      throw err;
    }
    if (!isDuplicate) dispatch(hideSpinner());
  };

export const getCategoriesData = (programId) => async (dispatch) => {
  dispatch(showSpinner());
  return getCategoriesListService(programId)
    .then((res) => {
      dispatch(getCategoriesDataAction(res));
    })
    .catch((err) => {
      dispatch(hideSpinner());
    });
};

export const getLineItemsData = (programId) => async (dispatch) => {
  dispatch(showSpinner());
  return getLineItemsService(programId)
    .then((res) => {
      dispatch(getLineItemsDataAction(res));
    })
    .catch((err) => {
      dispatch(hideSpinner());
    });
};

export const getProgramDetailsData = (programId) => async (dispatch) => {
  dispatch(showSpinner());
  return getProgramDetailsService(programId)
    .then((res) => {
      dispatch(getProgramDetailsAction(res));
      dispatch(hideSpinner());
    })
    .catch((err) => {
      dispatch(hideSpinner());
    });
};

export const getLineItemPricesData =
  (programId, isDuplicate = false) =>
  async (dispatch) => {
    return getLineItemPricesService(programId)
      .then((res) => {
        dispatch(getLineItemPricesAction(res));
        if (isDuplicate) return res;
        if (!isDuplicate) dispatch(hideSpinner());
      })
      .catch((err) => {
        dispatch(hideSpinner());
      });
  };

export const addLineItemPrices =
  (dataArray, isDuplicate = false) =>
  async (dispatch) => {
    if (dataArray.length > 1) dispatch(showSpinner());
    const results = await Promise.all(dataArray.map((data) => addLineItemPricesService(data)));
    dispatch(addLineItemPricesAction(results));
    if (!isDuplicate) dispatch(hideSpinner());
  };

export const updateLineItemPrices =
  (dataArray, isDuplicate = false) =>
  async (dispatch) => {
    if (dataArray.length > 1) dispatch(showSpinner());
    const results = await Promise.all(dataArray.map((data) => updateLineItemPricesService(data)));
    dispatch(addLineItemPricesAction(dataArray));
    if (!isDuplicate) dispatch(hideSpinner());
  };

export const editProgramDetail = (data) => async (dispatch) => {
  await editProgramDetailService(data);
  const res = await getProgramDetailsService(data.programId);
  dispatch(updateProgramDetailsAction(res));
  return res;
};

export const updateLineItemData = (data) => async (dispatch) => {
  return updateLineItemDataService(data)
    .then((res) => {
      dispatch(updateLineItemDataAction(res));
      dispatch(hideSpinner());
    })
    .catch((err) => {
      dispatch(hideSpinner());
    });
};

export const deleteLineItemData = (id) => async (dispatch) => {
  dispatch(showSpinner());
  return deleteLineItemDataService(id)
    .then((res) => {
      dispatch(deleteLineItemDataAction(id));
      dispatch(hideSpinner());
    })
    .catch((err) => {
      dispatch(hideSpinner());
      throw err;
    });
};

export const deleteProductData = (id) => async (dispatch) => {
  dispatch(showSpinner());
  return deleteProductDataService(id)
    .then((res) => {
      dispatch(deleteProductDataAction(id));
      dispatch(hideSpinner());
    })
    .catch((err) => {
      dispatch(hideSpinner());
      throw err;
    });
};
